export default __webpack_public_path__ + "static/media/java-logo.b309dd70.svg";